import dayjs from "dayjs";

export const dateFormat = "YYYY-MM-DD";
// Last second of today
export const todayDate = dayjs().endOf("day").startOf("second").toDate();
export const yesterdayDate = dayjs()
  .subtract(1, "day")
  .endOf("day")
  .startOf("second")
  .toDate();

export const AWeekLater = new Date(todayDate.getTime() + 7 * 24 * 3600000);

export const todayString = dayjs(todayDate).format(dateFormat);

export const getAMonthLaterStringFromDay = (date: Date) => {
  return dayjs(date).add(1, "month").format(dateFormat);
};

export const getAMonthPreviousStringFromDay = (date: Date) => {
  return dayjs(date).subtract(1, "month").format(dateFormat);
};

export const ifDateMoreThan1Year = (date: string) => {
  const now = dayjs();
  const futureDate = dayjs(date);
  const diff = now.diff(futureDate, "year", true);
  return diff > 1;
};
